import routerOptions0 from "/Users/kevin/jenkins/git/media/player-client-gay/node_modules/.pnpm/nuxt@3.18.0_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.1.0_@vue+compiler-sfc@3_oq2rdosjjisl75fucu5a75f7qe/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/Users/kevin/jenkins/git/media/player-client-gay/app/router.options.ts";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}